import { SvgIcon, SvgIconProps } from "@mui/material";
import { AlphaGlyphMinimized } from "src/components/icons-mui/alpha-icon-glyph";

export const IconAlphaLightMinimized = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 14 14">
        <g transform="translate(2.15 0)">
            <AlphaGlyphMinimized />
        </g>
    </SvgIcon>
);
